module.exports = __webpack_public_path__ + "img/47_26.90d601a1.png";